import React, { useEffect, useRef, useState } from 'react';
import { VncScreen, VncScreenHandle } from "react-vnc";
import { Box, CircularProgress } from "@mui/material";

const VncWindow = () => {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  const [dimensions, setDimensions] = useState({ width: 800, height: 600 });

  const handleConnect = (rfb: any) => {

    const fbWidth = rfb?._fbWidth || 800;
    const fbHeight = rfb?._fbHeight || 600;

    const screenMaxWidth = window.screen.width * 0.7;
    const screenMaxHeight = window.screen.height * 0.7;

    const widthRatio = screenMaxWidth / fbWidth;
    const heightRatio = screenMaxHeight / fbHeight;
    const scale = Math.min(widthRatio, heightRatio, 1); // avoid upscaling

    const finalWidth = Math.round(fbWidth * scale);
    const finalHeight = Math.round(fbHeight * scale);

    setDimensions({ width: finalWidth, height: finalHeight });

    try {
      const chromeWidth = window.outerWidth - window.innerWidth;
      const chromeHeight = window.outerHeight - window.innerHeight;

      const totalWidth = finalWidth + chromeWidth;
      const totalHeight = finalHeight + chromeHeight;

      window.resizeTo(totalWidth, totalHeight);

      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;

      const x = Math.max(0, Math.floor((screenWidth - totalWidth) / 2));
      const y = Math.max(0, Math.floor((screenHeight - totalHeight) / 2));

      window.moveTo(x, y);
    } catch (err) {
      console.warn("window resize/move may be blocked by browser:", err);
    }
  };

  const screenRef = useRef<VncScreenHandle>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (screenRef.current?.rfb) {
        handleConnect(screenRef.current?.rfb);
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      >
        <CircularProgress/>
      </Box>

      {token && (
        <VncScreen
          url={`wss://remoteview.devicehub.ai?token=${token}`}
          style={{
            width: `${dimensions.width}px`,
            height: `${dimensions.height}px`,
            position: 'relative',
            border: '1px solid #ccc',
          }}
          ref={screenRef}
          scaleViewport={true}
          showDotCursor={true}
        />
      )}
    </>
  )
}

export default VncWindow;
